<div>
  @if (surveyConditionalsService.questionSelected$().cards?.length > 0) {
    @if (surveyConditionalsService.conditionForm$().get('cardId')?.value) {
      <empathy-selected-value-view (onClear)="onClearCardSelected()">
        <div class="eiq-id-badge" slot="badge">
          <span>{{ surveyConditionalsService.conditionForm$().get('cardId').value }}</span>
        </div>
        <ng-container slot="text">
          <div class="carousel-logic-form__text">
            @if (selectedCard$()?.stimulus?.mediaId) {
              <empathy-shared-stimulus [stimulus]="[selectedCard$().stimulus]" [readonly]="true" [height]="35" [width]="42"></empathy-shared-stimulus>
            }
            {{ surveyConditionalsService.conditionForm$().get('cardId').value | cardText: surveyConditionalsService.questionSelected$() | toPlainText }}
          </div>
        </ng-container>
      </empathy-selected-value-view>
    } @else {
      <mat-form-field class="conditional__full-width" appearance="outline" [subscriptSizing]="'dynamic'">
        <mat-select
          [formControl]="surveyConditionalsService.conditionForm$().get('cardId') | toFormControl"
          [placeholder]="'Select a card'"
          (selectionChange)="onUpdateSelectedCardStimulus()"
          aria-label="Pick card for the condition"
        >
          @for (card of surveyConditionalsService.questionSelected$().cards; track card.id) {
            <mat-option [value]="card.id">
              {{ card.text | toPlainText }}
              @if (card.stimulus?.mediaId) {
                {{ card.stimulus.name }}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</div>
